import { render, staticRenderFns } from "./list-customers.vue?vue&type=template&id=161f593d&scoped=true&"
import script from "./list-customers.vue?vue&type=script&lang=js&"
export * from "./list-customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f593d",
  null
  
)

export default component.exports